var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_57221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E2E6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40601 12.8887H10.2324L10.4994 15.1188C10.4994 15.1188 8.9614 14.5797 8.40601 12.8887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2001 12.8677H21.3737L21.1067 15.0978C21.1067 15.0978 22.6447 14.5587 23.2001 12.8677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8726 11.8317H21.5122L21.7578 9.79189L21.2238 9.20001H10.4042L9.87019 9.79189L10.1158 11.8423H7.73405L7.20001 12.4342C7.21069 12.561 7.5952 15.4358 10.6499 16.3025L10.7033 16.7147L10.9276 17.0846L14.8581 19.7798H16.7379L20.6898 17.0846L20.914 16.7147L20.9674 16.2919C24.0115 15.4147 24.3853 12.5504 24.4066 12.4236L23.8726 11.8317ZM8.40693 12.8887H10.2333V12.8464L10.5004 15.1187C9.19731 14.5797 8.63123 13.5439 8.40693 12.8887ZM19.878 16.3448L15.7873 19.135L11.718 16.3448L11.0023 10.2569H20.6257L19.878 16.3448ZM21.1063 15.1187L21.3733 12.8887H23.1784C22.9541 13.5439 22.388 14.5797 21.0956 15.1187H21.1063Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7779 23.331H16.3427V19.7797H15.2746V23.331H12.7113L12.1879 23.7326L11.6752 25.7407L12.1986 26.396H19.2906L19.8033 25.7407L19.2799 23.7326L18.7672 23.331H18.7779ZM12.8822 25.3391L13.1278 24.3879H18.3614L18.607 25.3391H12.8928H12.8822Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0023 10.2569L11.7286 16.3553L15.798 19.135L19.8887 16.3447L20.6256 10.2569H11.0023Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1383 24.3882H18.3718L18.5961 25.3606H12.882L13.1383 24.3882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7794_57221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7935 11.4655L15.1472 12.7582L13.6774 12.988L14.7355 14.0029L14.4674 15.4583L15.7935 14.7977L17.1388 15.4583L16.8947 14.0364L17.9431 12.9688L16.5069 12.7582L15.7935 11.4655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0287 15.6737L15.7936 15.0609L14.5727 15.669L14.228 15.4104L14.4722 14.0795L13.5099 13.1603L13.6392 12.7533L14.9892 12.5475L15.5781 11.3602L16.0042 11.3506L16.6601 12.5379L17.9815 12.7294L18.1155 13.1363L17.1484 14.1178L17.3687 15.42L17.0287 15.6737ZM15.8989 14.5822L16.8181 15.037L16.6553 14.0747L16.7223 13.8688L17.4405 13.1363L16.4686 12.9927L16.2915 12.873L15.7983 11.9778L15.3531 12.8635L15.176 12.9927L14.1849 13.1459L14.8935 13.8305L14.9653 14.046L14.7834 15.0274L15.6787 14.5774H15.8941L15.8989 14.5822Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_57221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7794_57221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.60563,
    height: 4.32316,
    fill: "white",
    transform: "translate(13.5099 11.3506)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarTrophyIcon);
export default __webpack_public_path__ + "static/media/star-trophy-icon.2733d1686e2624cc7c213e6a7324f3ca.svg";
export { ForwardRef as ReactComponent };